import React from 'react';
import './App.css';
import TopicSearch from './TopicSearch';

function App() {
  return (
    <div className="App">
      <TopicSearch />
    </div>
  );
}

export default App;
